import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface LeaderboardEntry {
  userId: number;
  name: string;
  surname: string;
  days: number;
  kcal?: number;
  kg?: number;
  _sum?: {
    kcal?: number;
    kg?: number;
  };
}

export interface RankingData {
  currentMonth: LeaderboardEntry[];
  lastMonth: LeaderboardEntry[];
  level: number;
  exp: number;
  expToLevelUp: number;
  scoreTotal: number;
  currentLevelMin: number;
  nextLevelMin: number;
}

const queryOptions = {
  queryKey: ['ranking'],
  queryFn: async () => {
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.get<RankingData>(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/ranking`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      return data;
    } catch (error: any) {
      if ( error.response && error.response.status === 401 && error.response.data.error === "Invalid or missing API key"
      ) { 
        logout()
      } 
      throw error;
    } 
  },
} as any;

export const useRanking = () => {
  return useQuery<RankingData, Error>(queryOptions);
};
